export enum SubTopNavBarVariants {
  Page = "page",
  Drawer = "drawer"
}

export enum SubTopNavBarHelperText {
  DisabledBackNavActionMessage = "This action isn't supported in a new tab since there's no previous page in the browsing history."
}
